/*
 * Project: BookingEngine
 * Module: components/icons/highlights/OccupancyIcon.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';

const OccupancyIcon = () => (
  <svg className="svg-icon highlight-occupancy-icon" width="28px" height="28px" viewBox="0 0 28 28" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient x1="50%" y1="100%" x2="50%" y2="-1.74574067e-13%" id="linearGradient-1">
        <stop stopColor="#000000" stopOpacity="0" offset="0%"/>
        <stop stopColor="#000000" offset="100%"/>
      </linearGradient>
    </defs>
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon/facilities/occupancy" transform="translate(-6.000000, -6.000000)">
        <g id="family" transform="translate(6.000000, 6.000000)">
          <g id="man">
            <path
              d="M2.0513167,16.3162278 L6,15 L10,15 L13.9486833,16.3162278 C15.1737097,16.7245699 16,17.8709864 16,
              19.1622777 L16,28 L0,28 L0,19.1622777 C-1.58137566e-16,17.8709864 0.826290285,16.7245699 2.0513167,
              16.3162278 Z" fill="#18BAB7" />
            <polygon id="Rectangle-18-Copy" fill="url(#linearGradient-1)" style={{ mixBlendMode: 'overlay' }}
                     points="3 20 4 28 2 28" />
            <polygon id="Rectangle-18-Copy-3" fill="url(#linearGradient-1)" style={{ mixBlendMode: 'overlay' }}
                     points="13 20 14 28 12 28" />
            <path
              d="M3,4 L13.0000143,4 L13,11 C12.9999976,12.6568526 11.6568526,13.9999957 10,13.9999957 L10,14 L10,
              16 L8,17 L6,16 L6,14 L6,14 C4.34314575,14 3,12.6568542 3,11 L3,4 Z" fill="#EED8D2" />
            <polygon id="Rectangle-16-Copy-3" fill="url(#linearGradient-1)" style={{ mixBlendMode: 'overlay' }}
                     points="6 14 10 14 10 16 8 17 6 16"/>
            <rect fill="#FFFFFF" x="5" y="7" width="1" height="1" />
            <rect fill="#005CB9" x="6" y="7" width="1" height="1" />
            <rect fill="#FFFFFF" x="10" y="7" width="1" height="1" />
            <rect fill="#005CB9" x="9" y="7" width="1" height="1" />
            <path
              d="M5,10 L6,10 L6,10 C6,10.5522847 6.44771525,11 7,11 L9,11 C9.55228475,11 10,10.5522847 10,
              10 L11,10 L11,10 C11,11.1045695 10.1045695,12 9,12 L7,12 C5.8954305,12 5,11.1045695 5,10 Z"
              fill="#F83154" opacity="0.4"/>
            <path
              d="M5,0 L11,0 L11,1 L12,1 C12.5522847,1 13,1.44771525 13,2 L13,6 L13,6 C11.8954305,6 11,5.1045695 11,
              4 L11,4 C11,5.1045695 10.1045695,6 9,6 L3,6 L3,2 C3,0.8954305 3.8954305,2.02906125e-16 5,0 Z"
              fill="#8B572A"/>
          </g>
          <g id="woman" transform="translate(16.000000, 0.000000)">
            <rect fill="#F5A623" x="1" y="6" width="10" height="11" />
            <rect fill="#000000" opacity="0.200000003" x="2" y="6" width="8" height="11" />
            <path
              d="M1.65835921,16.1708204 L2,16 L2,28 L0,28 L0,18.854102 C-1.39158597e-16,17.7177858 0.642007129,
              16.6789964 1.65835921,16.1708204 Z" fill="#F6CFBE" />
            <path d="M10,16 L10,16 C11.2257321,16.6128661 12,17.8656578 12,19.236068 L12,28 L10,28 L10,16 Z"
                  fill="#F6CFBE" />
            <path
              d="M2,16 L4,15 L8,15 L10,16 L10.6837722,20.7864056 C10.8896845,22.2277913 10.6511517,23.6976967 10,
              25 L10,28 L2,28 L2,25 L2,25 C1.34884835,23.6976967 1.11031553,22.2277913 1.31622777,20.7864056 L2,16 Z"
              fill="#F8E71C" />
            <polygon fill="url(#linearGradient-1)" style={{ mixBlendMode: 'multiply' }} opacity="0.195652174"
                     points="6 23 10 25 2 25" />
            <path d="M4,13 L8,13 L8,16 C8,17.1045695 7.1045695,18 6,18 L6,18 C4.8954305,18 4,17.1045695 4,16 L4,13 Z"
                  fill="#F6CFBE" />
            <path d="M4,13 L8,13 L8,16 C8,17.1045695 7.1045695,18 6,18 L6,18 C4.8954305,18 4,17.1045695 4,16 L4,13 Z"
                  fill="url(#linearGradient-1)" style={{ mixBlendMode: 'overlay' }} />
            <path d="M2,2 L10,2 L10,10 C10,12.209139 8.209139,14 6,14 L6,14 C3.790861,14 2,12.209139 2,10 L2,2 Z"
                  fill="#F6CFBE" />
            <rect fill="#FFFFFF" x="3" y="7" width="1" height="1" />
            <rect fill="#18BAB7" x="4" y="7" width="1" height="1" />
            <rect fill="#FFFFFF" x="8" y="7" width="1" height="1" />
            <rect fill="#18BAB7" x="7" y="7" width="1" height="1" />
            <path
              d="M4,10 L5,10 L5,10 C5,10.5522847 5.44771525,11 6,11 L6,11 C6.55228475,11 7,10.5522847 7,10 L8,10 L8,
              10 C8,11.1045695 7.1045695,12 6,12 L6,12 C4.8954305,12 4,11.1045695 4,10 Z" fill="#F83154" opacity="0.4"/>
            <path
              d="M3.41165159,0.517669681 L5.01941932,0.196116135 C5.46339212,0.107321575 5.8952854,
              0.395250428 5.98407996,0.839223227 C5.99466743,0.892160576 6,0.946014285 6,1 L6,1 C6,
              0.547234807 6.36703871,0.180196097 6.8198039,0.180196097 C6.87378962,0.180196097 6.92764333,
              0.185528665 6.98058068,0.196116135 L8.58834841,0.517669681 C9.990621,0.798124199 11,2.02936865 11,
              3.45941171 L11,6 L8,6 C6.8954305,6 6,5.1045695 6,4 L6,4 C6,5.1045695 5.1045695,6 4,6 L1,6 L1,
              3.45941171 C1,2.02936865 2.009379,0.798124199 3.41165159,0.517669681 Z" fill="#F5A623" />
          </g>
          <g id="girl" transform="translate(9.000000, 14.000000)">
            <rect fill="#DE811D" x="0" y="6" width="10" height="8" />
            <rect fill="#000000" opacity="0.200000003" x="1" y="6" width="8" height="8" />
            <rect fill="#F6DBD0" x="3" y="12" width="4" height="2" />
            <rect fill="url(#linearGradient-1)" style={{ mixBlendMode: 'overlay' }} x="3" y="12" width="4" height="2" />
            <path d="M1,4 L9,4 L9,9 C9,11.209139 7.209139,13 5,13 L5,13 C2.790861,13 1,11.209139 1,9 L1,4 Z"
                  fill="#F6DBD0" />
            <rect fill="#FFFFFF" x="2" y="7" width="1" height="1" />
            <rect fill="#005CB9" x="3" y="7" width="1" height="1" />
            <rect fill="#FFFFFF" x="7" y="7" width="1" height="1" />
            <rect fill="#005CB9" x="6" y="7" width="1" height="1" />
            <path
              d="M3,9 L4,9 L4,9 C4,9.55228475 4.44771525,10 5,10 L5,10 C5.55228475,10 6,9.55228475 6,9 L7,9 L7,
              9 C7,10.1045695 6.1045695,11 5,11 L5,11 C3.8954305,11 3,10.1045695 3,9 Z" fill="#F83154" opacity="0.4" />
            <path
              d="M1.45651273,2.12609236 L2.5,1.5 C4.03879981,0.576720117 5.96120019,0.576720117 7.5,1.5 L8.54348727,
              2.12609236 C9.4471035,2.6682621 10,3.64478258 10,4.69857114 L10,7 L9.68328157,6.89442719 C7.91867839,
              6.30622613 6.31525755,5.31525755 5,4 L5,4 C3.68474245,5.31525755 2.08132161,6.30622613 0.316718427,
              6.89442719 L0,7 L4.4408921e-16,4.69857114 C3.15037332e-16,3.64478258 0.552896501,2.6682621 1.45651273,
              2.12609236 Z" fill="#DE811D" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default OccupancyIcon;
